import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-homeone-case-studies',
    templateUrl: './homeone-case-studies.component.html',
    styleUrls: ['./homeone-case-studies.component.scss']
})
export class HomeoneCaseStudiesComponent implements OnInit {

    constructor() { }

    ngOnInit(): void {
    }

    singleCaseStudyItem: singleCaseStudyItemContent[] = [
        {
            subTitle: 'Our Story',
            title: 'Multiple Industries, Repeat Clients!',
            paragraphText1: 'We started in early 4 with a single model to detect labels on pills packaging line. Since then, we have built over 20 machine learning models for various purposes and have served clients from multiple industries. We are based in the heart of the Silicon Valley and have been growing organically without any venture funding. Our team has just one vision, and that is to solve problems with data intelligence without requiring any data scientists or even coding!',
            paragraphText2: 'Our cloud based data intelligence solution works with any data source be it streaming or at rest. The workflow is completely modular for you to choose just the intelligence you need for your process.',
            link: 'case-studies-details-1',
            linkText: 'Details More',
            linkIcon: 'flaticon-view',
            img: 'https://imgvid.blob.core.windows.net/imgvid/case-study.png'
        }
    ]

    Cases: Cases[] = [
        {
            icon: 'bx bx-book-bookmark',
            title: 'Case Study 1',
            subTitle: 'CentralPharma - Quality Checks',
            location: '/case-study-1'
        },
        {
            icon: 'bx bx-book-bookmark',
            title: 'Case Study 2',
            subTitle: 'Aarvy Hospital - Crowd Control',
            location: '/case-study-2'
        },
        {
            icon: 'bx bx-book-bookmark',
            title: 'Case Study 3',
            subTitle: 'Best Western Resort - LPR',
            location: '/case-study-3'
        }
    ]
}
class singleCaseStudyItemContent {
    subTitle : string;
    title : string;
    paragraphText1 : string;
    paragraphText2 : string;
    link : string;
    linkText : string;
    linkIcon : string;
    img : string;
}

class Cases {
    icon : string;
    title : string;
    subTitle : string;
    location : string;
}